module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAKCAYAAACE2W/HAAAAuElEQVQokX3RMWoCQRiA0ZfVFDaCbTq7QI5gITnABCxS2IpFuvSmyRlsZCsDtmIsBC8hBLxCGrE2pNKkcAOTdXennDffzMB/laapgvWEb8xwKrIkt9nAKyY45KJ/Vo+giTf0MMJ7lf2Ft5jiDo+YR1GhJbjHCtfo5qJSq2OANob4iKKkwtRCCBvc4AWt7MAXflBmEnyij+fshTVCdnGpxeMYo4MdFniosloIIXJ7LJ2Hf8Q2+/KF/QIymTiEoKOn5AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/icons/icon_arrow_left.png
// module id = AWSl
// module chunks = 0